// extracted by mini-css-extract-plugin
export default {"content":"OfferTypeList_content__wYggf","offerTypeListItem":"OfferTypeList_offerTypeListItem__8Fscx"};